// ドメイン制限と認証チェック機能

/**
 * 許可されたEmailドメインリスト
 * 環境変数で設定可能、デフォルトはfull-kaiten.comのみ
 */
export function getAllowedDomains(): string[] {
  const envDomains = import.meta.env.VITE_ALLOWED_DOMAINS;

  if (envDomains) {
    const domains = envDomains.split(',').map((domain) => domain.trim());
    return domains;
  }

  // デフォルトドメイン（環境変数が設定されていない場合）
  const defaultDomains = ['full-kaiten.com'];

  return defaultDomains;
}

/**
 * Emailアドレスのドメインが許可されているかチェック
 */
export function isEmailDomainAllowed(email?: string | null): boolean {
  if (!email) {
    return false;
  }

  if (!email.includes('@')) {
    return false;
  }

  const domain = email.split('@')[1].toLowerCase();
  const allowedDomains = getAllowedDomains();

  const isAllowed = allowedDomains.includes(domain);

  return isAllowed;
}

/**
 * ユーザーがワークスペースに属するかチェック
 * Cognitoのユーザープールグループやカスタム属性を使用する場合の拡張ポイント
 */
export function isUserInWorkspace(user?: { email?: string | null; name?: string | null }): boolean {
  if (!user?.email) {
    return false;
  }

  const isAllowed = isEmailDomainAllowed(user.email);

  if (!isAllowed) {
    return false;
  }

  return true;
}

/**
 * 認証エラーの種類
 */
export enum AuthError {
  DOMAIN_NOT_ALLOWED = 'DOMAIN_NOT_ALLOWED',
  NOT_IN_WORKSPACE = 'NOT_IN_WORKSPACE',
  TOKEN_INVALID = 'TOKEN_INVALID',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

/**
 * 認証エラーメッセージを取得
 */
export function getAuthErrorMessage(error: AuthError): string {
  switch (error) {
    case AuthError.DOMAIN_NOT_ALLOWED:
      return 'このEmailドメインは許可されていません。組織のアカウントでログインしてください。';
    case AuthError.NOT_IN_WORKSPACE:
      return 'このワークスペースへのアクセス権限がありません。';
    case AuthError.TOKEN_INVALID:
      return '認証トークンが無効です。再度ログインしてください。';
    case AuthError.UNAUTHORIZED:
      return 'アクセス権限がありません。';
    default:
      return '認証エラーが発生しました。';
  }
}
